
<template>
  <div id="">
    <!-- 顶部大图--头 -->
    <div class="banner">
      <!-- <img src="../assets/img/introduction/banner.svg" alt="" /> -->
      <h5>醴陵金融纠纷调解中心</h5>
    </div>
    <!-- 导航栏--头 -->
    <div class="nav">
      <router-link v-for="(item, index) in list" :key="index" :to="item.path" :class="name == index ? 'nav-01' : ''">
        <span></span>
        <p>{{ item.title }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    name: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      list: [
        {
          title: "调解中心简介",
          path: "/introduction"
        }, {
          title: "调解指南",
          path: "/fingerpost"
        },
        {
          title: "调解员名录",
          path: "/list"
        },
        {
          title: "判决案例",
          path: "/JudgmentCase"
        },
        {
          title: "法政法规",
          path: "/law"
        }
      ]
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.banner {
  background-image: url('../assets/img/introduction/banner.svg');
  height: 8.5rem;
  margin: 0 0 1.75rem 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: #fff;
}



.nav {
  width: 100%;
  margin-top: -0.625rem;
  display: flex;
  margin-bottom: 1.75rem;
  overflow: auto;
  z-index: -1;

}

::-webkit-scrollbar {
  display: none;
}

.nav .nav-01 span {
  display: inline-block;
  width: 0.9375rem;
  height: 0.9375rem;
  background: url(../assets/img/base/tjzxjj.svg) no-repeat center center;
}

.nav .nav-01 p {
  display: inline-block;
  font-weight: 500;
  color: #2b4ca4;
}

.nav a {
  font-size: 0.875rem;
  color: #333;
  white-space: nowrap;
  margin-right: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/interiorH.vue